/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/**
 * 矩阵站公共配置
 * -----------------------------------------------------------------------------
 * 1. 每个二级分类（catId）对应一个独立的三级域名站点，站点的 nav key 作为子域名前缀。
 * 2. 三级分类（subCat）在各站点内做"首页 + 三级分类切换 button"。
 * 3. 排行榜、书籍类型与后端 matrixV2/common.ts 保持一致。
 * -----------------------------------------------------------------------------
 */

export interface ISubCategory {
  subCatName: string
  subCatId: number
}

export interface ICategory {
  /** 二级分类 ID（后端 catId） */
  catId: number
  /** 站点 key（英文短名，作为子域名前缀） */
  key: string
  /** 站点导航/子域名前缀（等价于 key，保留兼容字段） */
  nav: string
  /** 二级分类中文名 */
  catName: string
  /** 站点展示名称（SEO/Header Title） */
  siteName: string
  /** 三级分类列表 */
  subCat: ISubCategory[]
}

export interface ITabItem {
  title: string
  keyName: string
}

// ---------------------------------------------------------------------------
// 排行榜（与后端 matrixV2/common.ts 对齐）
// ---------------------------------------------------------------------------
export const rankTabs: ITabItem[] = [
  { title: '月票榜', keyName: 'fyRank' },
  { title: '畅销榜', keyName: 'hotRank' },
  { title: '阅读榜', keyName: 'readIndex' },
  { title: '书友榜', keyName: 'newFans' },
  { title: '推荐榜', keyName: 'recRank' },
  { title: '新书榜', keyName: 'newbRank' },
  { title: '完结榜', keyName: 'overRank' },
]

// ---------------------------------------------------------------------------
// 书籍圈选类型（首页 / 二级页）
// ---------------------------------------------------------------------------
export const bookTypes: ITabItem[] = [
  { title: '热门小说', keyName: 'hotBook' },
  { title: '完本好书', keyName: 'overBook' },
  { title: '最新更新', keyName: 'newBook' },
  { title: '新书精选', keyName: 'newbBook' },
  { title: '免费好书', keyName: 'freeBook' },
]

// 非"热门小说"的 bookType 子集（首页区块 / 二级页接口参数）
export const bookTypesWithoutHot: ITabItem[] = bookTypes.filter(
  (item) => item.keyName !== 'hotBook',
)

// ---------------------------------------------------------------------------
// 二级分类站点列表
// ---------------------------------------------------------------------------
export const categoryList: ICategory[] = [
  {
    catId: 21,
    key: 'xuanhuan',
    nav: 'xuanhuan',
    catName: '玄幻',
    siteName: '玄幻小说网',
    subCat: [
      { subCatName: '东方玄幻', subCatId: 8 },
      { subCatName: '异世大陆', subCatId: 73 },
      { subCatName: '王朝争霸', subCatId: 58 },
      { subCatName: '高武世界', subCatId: 78 },
    ],
  },
  {
    catId: 1,
    key: 'qihuan',
    nav: 'qihuan',
    catName: '奇幻',
    siteName: '奇幻小说网',
    subCat: [
      { subCatName: '现代魔法', subCatId: 38 },
      { subCatName: '剑与魔法', subCatId: 62 },
      { subCatName: '史诗奇幻', subCatId: 201 },
      { subCatName: '神秘幻想', subCatId: 202 },
      { subCatName: '历史神话', subCatId: 20092 },
      { subCatName: '另类幻想', subCatId: 20093 },
    ],
  },
  {
    catId: 2,
    key: 'wuxia',
    nav: 'wuxia',
    catName: '武侠',
    siteName: '武侠小说网',
    subCat: [
      { subCatName: '传统武侠', subCatId: 5 },
      { subCatName: '武侠幻想', subCatId: 30 },
      { subCatName: '国术无双', subCatId: 206 },
      { subCatName: '古武未来', subCatId: 20099 },
      { subCatName: '武侠同人', subCatId: 20100 },
    ],
  },
  {
    catId: 22,
    key: 'xianxia',
    nav: 'xianxia',
    catName: '仙侠',
    siteName: '仙侠小说网',
    subCat: [
      { subCatName: '修真文明', subCatId: 18 },
      { subCatName: '幻想修仙', subCatId: 44 },
      { subCatName: '现代修真', subCatId: 64 },
      { subCatName: '神话修真', subCatId: 207 },
      { subCatName: '古典仙侠', subCatId: 20101 },
    ],
  },
  {
    catId: 4,
    key: 'dushi',
    nav: 'dushi',
    catName: '都市',
    siteName: '都市小说网',
    subCat: [
      { subCatName: '爱情婚姻', subCatId: 65535 },
      { subCatName: '都市生活', subCatId: 12 },
      { subCatName: '都市异能', subCatId: 16 },
      { subCatName: '异术超能', subCatId: 74 },
      { subCatName: '青春校园', subCatId: 130 },
      { subCatName: '娱乐明星', subCatId: 151 },
      { subCatName: '商战职场', subCatId: 153 },
    ],
  },
  // {
  //   catId: 15,
  //   key: 'xianshi',
  //   nav: 'xianshi',
  //   catName: '现实',
  //   siteName: '现实小说网',
  //   subCat: [
  //     { subCatName: '时代叙事', subCatId: 20106 },
  //     { subCatName: '家庭伦理', subCatId: 6 },
  //     { subCatName: '女性题材', subCatId: 20104 },
  //     { subCatName: '青年故事', subCatId: 20108 },
  //     { subCatName: '社会悬疑', subCatId: 20105 },
  //     { subCatName: '人间百态', subCatId: 209 },
  //     { subCatName: '成功励志', subCatId: 20107 },
  //   ],
  // },
  // {
  //   catId: 6,
  //   key: 'junshi',
  //   nav: 'junshi',
  //   catName: '军事',
  //   siteName: '军事小说网',
  //   subCat: [
  //     { subCatName: '军旅生涯', subCatId: 54 },
  //     { subCatName: '军事战争', subCatId: 65 },
  //     { subCatName: '战争幻想', subCatId: 80 },
  //     { subCatName: '抗战烽火', subCatId: 230 },
  //     { subCatName: '谍战特工', subCatId: 231 },
  //   ],
  // },
  {
    catId: 5,
    key: 'lishi',
    nav: 'lishi',
    catName: '历史',
    siteName: '历史小说网',
    subCat: [
      { subCatName: '架空历史', subCatId: 22 },
      { subCatName: '秦汉三国', subCatId: 48 },
      { subCatName: '上古先秦', subCatId: 220 },
      { subCatName: '历史传记', subCatId: 32 },
      { subCatName: '两晋隋唐', subCatId: 222 },
      { subCatName: '五代十国', subCatId: 223 },
      { subCatName: '两宋元明', subCatId: 224 },
      { subCatName: '清史民国', subCatId: 225 },
      { subCatName: '外国历史', subCatId: 226 },
      { subCatName: '民间传说', subCatId: 20094 },
    ],
  },
  {
    catId: 7,
    key: 'youxi',
    nav: 'youxi',
    catName: '游戏',
    siteName: '游戏小说网',
    subCat: [
      { subCatName: '电子竞技', subCatId: 7 },
      { subCatName: '虚拟网游', subCatId: 70 },
      { subCatName: '游戏异界', subCatId: 240 },
      { subCatName: '游戏系统', subCatId: 20102 },
      { subCatName: '游戏主播', subCatId: 20103 },
    ],
  },
  // {
  //   catId: 8,
  //   key: 'tiyu',
  //   nav: 'tiyu',
  //   catName: '体育',
  //   siteName: '体育小说网',
  //   subCat: [
  //     { subCatName: '篮球运动', subCatId: 28 },
  //     { subCatName: '体育赛事', subCatId: 55 },
  //     { subCatName: '足球运动', subCatId: 82 },
  //   ],
  // },
  {
    catId: 9,
    key: 'kehuan',
    nav: 'kehuan',
    catName: '科幻',
    siteName: '科幻小说网',
    subCat: [
      { subCatName: '古武机甲', subCatId: 21 },
      { subCatName: '未来世界', subCatId: 25 },
      { subCatName: '星际文明', subCatId: 68 },
      { subCatName: '超级科技', subCatId: 250 },
      { subCatName: '时空穿梭', subCatId: 251 },
      { subCatName: '进化变异', subCatId: 252 },
      { subCatName: '末世危机', subCatId: 253 },
    ],
  },
  // {
  //   catId: 10,
  //   key: 'lingyi',
  //   nav: 'lingyi',
  //   catName: '悬疑',
  //   siteName: '悬疑小说网',
  //   subCat: [
  //     { subCatName: '诡秘悬疑', subCatId: 26 },
  //     { subCatName: '奇妙世界', subCatId: 35 },
  //     { subCatName: '侦探推理', subCatId: 57 },
  //     { subCatName: '探险生存', subCatId: 260 },
  //     { subCatName: '古今传奇', subCatId: 20095 },
  //   ],
  // },
  {
    catId: 20109,
    key: 'zhutianwuxian',
    nav: 'zhutianwuxian',
    catName: '诸天无限',
    siteName: '诸天无限小说网',
    subCat: [
      { subCatName: '无限', subCatId: 20110 },
      { subCatName: '诸天', subCatId: 20111 },
      { subCatName: '综漫', subCatId: 20112 },
    ],
  },
  {
    catId: 12,
    key: '2cy',
    nav: '2cy',
    catName: '轻小说',
    siteName: '轻小说网',
    subCat: [
      { subCatName: '原生幻想', subCatId: 60 },
      { subCatName: '现代幻想', subCatId: 10 },
      { subCatName: '衍生同人', subCatId: 281 },
      { subCatName: '搞笑吐槽', subCatId: 282 },
      { subCatName: '恋爱日常', subCatId: 66 },
    ],
  },
  // {
  //   catId: 20076,
  //   key: 'duanpian',
  //   nav: 'duanpian',
  //   catName: '短篇',
  //   siteName: '短篇小说网',
  //   subCat: [
  //     { subCatName: '诗歌散文', subCatId: 20097 },
  //     { subCatName: '人物传记', subCatId: 20098 },
  //     { subCatName: '影视剧本', subCatId: 20075 },
  //     { subCatName: '评论文集', subCatId: 20077 },
  //     { subCatName: '生活随笔', subCatId: 20078 },
  //     { subCatName: '美文游记', subCatId: 20079 },
  //     { subCatName: '短篇小说', subCatId: 20096 },
  //   ],
  // },
]

// ---------------------------------------------------------------------------
// 域名 & 环境
// ---------------------------------------------------------------------------
/** 环境前缀（pro 为空；其他环境作为 host 前缀） */
export const getEnvPrefix = (): string => {
  const env = import.meta.env.VITE_ENV_TYPE
  if (env === 'pro') return ''
  // 保留 oa/pre 等作为前缀；local 走 pre
  if (env === 'local') return 'pre'
  return String(env || '')
}

/** 后端矩阵站接口基础地址 */
export const MATRIX_API_BASE: string =
  import.meta.env.VITE_ENV_TYPE === 'pro'
    ? 'https://seo.yuewen.com'
    : 'https://preseo.yuewen.com'

// ---------------------------------------------------------------------------
// Helper
// ---------------------------------------------------------------------------
/** 根据 catId 获取分类 */
export const getCategoryByCatId = (
  catId: number | string,
): ICategory | null => {
  const id = Number(catId)
  return categoryList.find((c) => c.catId === id) || null
}

/** 根据 nav/key 获取分类 */
export const getCategoryByNav = (nav: string): ICategory | null => {
  return categoryList.find((c) => c.nav === nav || c.key === nav) || null
}

/** 根据 catId + subCatId 获取三级分类 */
export const getSubCategory = (
  catId: number | string,
  subCatId: number | string,
): ISubCategory | null => {
  const category = getCategoryByCatId(catId)
  if (!category) return null
  const sid = Number(subCatId)
  return category.subCat.find((s) => s.subCatId === sid) || null
}
